import React, { useState } from 'react';
import Button from '../../../components/ui/Button';
import { useLanguage } from '../../../contexts/LanguageContext';

const StepStoryQuestions = ({ data, onNext, onBack }) => {
  const { t } = useLanguage();
  const [formData, setFormData] = useState({
    whatYouLove: data?.storyAnswers?.whatYouLove || '',
    renovations: data?.storyAnswers?.renovations || '',
    idealBuyer: data?.storyAnswers?.idealBuyer || ''
  });

  const handleSubmit = (e) => {
    e?.preventDefault();
    onNext({ storyAnswers: formData });
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold text-foreground mb-2">{t('tellYourStoryTitle')}</h2>
        <p className="text-muted-foreground">{t('tellYourStoryDesc')}</p>
      </div>

      <div className="space-y-6">
        <div className="space-y-2">
          <label className="text-sm font-medium text-foreground">
            {t('whatYouLoveLabel')}
          </label>
          <textarea
            value={formData?.whatYouLove}
            onChange={(e) => setFormData({ ...formData, whatYouLove: e?.target?.value })}
            rows={4}
            className="w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
            placeholder={t('whatYouLovePlaceholder')}
          />
        </div>

        <div className="space-y-2">
          <label className="text-sm font-medium text-foreground">
            {t('renovationsLabel')}
          </label>
          <textarea
            value={formData?.renovations}
            onChange={(e) => setFormData({ ...formData, renovations: e?.target?.value })}
            rows={4}
            className="w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
            placeholder={t('renovationsPlaceholder')}
          />
        </div>

        <div className="space-y-2">
          <label className="text-sm font-medium text-foreground">
            {t('idealBuyerLabel')}
          </label>
          <textarea
            value={formData?.idealBuyer}
            onChange={(e) => setFormData({ ...formData, idealBuyer: e?.target?.value })}
            rows={4}
            className="w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
            placeholder={t('idealBuyerPlaceholder')}
          />
        </div>
      </div>

      <div className="flex justify-between">
        <Button type="button" variant="outline" onClick={onBack} iconName="ArrowLeft">{t('back')}</Button>
        <Button type="submit" variant="default" iconName="ArrowRight" iconPosition="right">{t('continue')}</Button>
      </div>
    </form>
  );
};

export default StepStoryQuestions;